import React from 'react';
import { Tooltip } from 'react-tooltip';

import { URGENCY_TOOLTIPS } from '@constants/urgencyTooltips';

import useTranslation from '@hooks/useTranslation';

import style from './style.module.scss';

interface IProps {
  statistic: {
    critical: number;
    high: number;
    standard: number;
    total: number;
  };
}

const ActionItemsSummary: React.FC<IProps> = ({ statistic }) => {
  const { t } = useTranslation();

  const highAi = statistic.total ? (statistic.high / statistic.total) * 100 : 0;
  const criticalAi = statistic.total ? (statistic.critical / statistic.total) * 100 : 0;
  const standardAi = statistic.total ? (statistic.standard / statistic.total) * 100 : 0;

  return (
    <>
      <div id="tourStep-10" className={style.summaryBlock}>
        <div className={style.summaryBlockTotal}>
          <span className={style.summaryBlockTotalName}>{t('Need response ai')}:</span>
          <span className={style.summaryBlockCount}>{statistic.total}</span>
        </div>
        <div className={style.summaryBlockBox}>
          <div
            className={style.summaryBlockItem}
            data-tooltip-id="summary-item-tooltip"
            data-tooltip-content={URGENCY_TOOLTIPS['Critical']}
          >
            <span className={style.summaryBlockName}>{t('Critical')}</span>
            <span
              className={style.progressCritical}
              style={{
                width: `${criticalAi}%`,
              }}
            ></span>
            <span className={style.summaryBlockCount}>{statistic.critical}</span>
          </div>
          <div
            className={style.summaryBlockItem}
            data-tooltip-id="summary-item-tooltip"
            data-tooltip-content={URGENCY_TOOLTIPS['High']}
          >
            <span className={style.summaryBlockName}>{t('High')}</span>
            <span
              className={style.progressHigh}
              style={{
                width: `${highAi}%`,
              }}
            ></span>
            <span className={style.summaryBlockCount}>{statistic.high}</span>
          </div>
          <div
            className={style.summaryBlockItem}
            data-tooltip-id="summary-item-tooltip"
            data-tooltip-content={URGENCY_TOOLTIPS['Standard']}
          >
            <span className={style.summaryBlockName}>{t('Standard')}</span>
            <span
              className={style.progressStandard}
              style={{
                width: `${standardAi}%`,
              }}
            ></span>
            <span className={style.summaryBlockCount}>{statistic.standard}</span>
          </div>
        </div>
      </div>
      <Tooltip id="summary-item-tooltip" className={style.summaryBlockItemTooltip} place={'left'} />
    </>
  );
};

export default ActionItemsSummary;
